<template>
  <div class="headerTop">
    <div class="visText">
      <h1>{{$t('data.headText.pageFive.pageText.visionText')}}</h1>
      <p>VVC vision system</p>
      <div>{{$t('data.headText.pageFive.pageText.column')}}</div>
    </div>
    <div>
      <div class="ALlvisImg">
        <div v-for="(item,index) in allVideo" :key="index" class="visImg" @click="videoShow(index)">
          <div>
            <img :src="item.img+'?x-oss-process=video/snapshot,t_0,f_jpg,w_260,m_fast'"/>
            <!--<img src="http://vvc-res.oss-cn-hangzhou.aliyuncs.com/vvc_web/1547624743017.jpg" alt="">-->
          </div>
          <div class='allvistit'>{{item.title}}</div>
        </div>
      </div>
    </div>
    <div v-if="videoDo" @click="videoOut()" class="videoAll">
    </div>
    <div v-if="videoDo" class="videoDiv">
      <div class="videAll">
        <!-- <h1>2018 배럴걸 고준희 2nd 룩북</h1> -->
        <h1>{{videoIndex.title}}</h1>
        <div class="video">
          <video controls="controls" :src="videoIndex.img"></video>
        </div>
        <!--<span class="openVideo">播放</span>-->
        <span class="openVideo" @click="videoOut()">退出</span>
      </div>
    </div>
      <div class="pageAll">
        <span class="SpanClick" v-for="(item , index) in videoNum" :key="index" :style='item==num ? "background:#9B9B9B;color:#fff":""'  @click="listVideo(item)">{{item}}</span>
      </div>
  </div>
</template>

<script>
  export default {
    name: "vision",
    data() {
      return {
        videoDo: false,
        allVideo: {},
        videoIndex: '',
        videoNum: '',
        videoSpan: '',
        num:0
      }
    },
    created() {
      this.visAll()
    },
    methods: {
      videoShow(i) {
        this.videoDo = !this.videoDo
        this.videoIndex = this.allVideo[i]
      },
      listVideo(a) {
        this.num=a
        this.req.post('http://jd1.vvc.tw/admin/goods/getVisionAll', this.qs.stringify({
          pages: this.num,
          num: '12'
        })).then((res) => {
          this.allVideo = res.data.data
          console.log(this.allVideo);
        }).catch((err) => {
          console.log(err);
        })
        console.log(a);
      },
      videoOut() {
        this.videoDo = !this.videoDo
      },
      visAll() {
        this.req.post('http://jd1.vvc.tw/admin/goods/getVisionAll').then((res) => {
          this.allVideo = res.data.data
          // console.log(this,allVideo,'152')
          this.videoNum = Math.ceil((this.allVideo.length + 1) / 12)
          // console.log(this.videoNum,'135')
          console.log(this.videoNum + '数量');
          console.log(this.allVideo)
          this.listVideo(1)
        }).catch((err) => {
          console.log(err);
        })
      },

    },
  }
</script>

<style scoped lang="stylus">
  .headerTop
    padding-top 86px
    width 1920px
    margin 0 auto
    padding-bottom 143px
  .visText
    padding-top 92px
    padding-bottom 60px
    h1
      text-align center
      margin 0 auto
      width: 435px;
      height: 45px;
      font-size: 32px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(74, 74, 74, 1);
      line-height: 45px;
    p
      text-align center
      margin: 6px auto 12px;
      width: 435px;
      height: 19px;
      font-size: 16px;
      font-family: SFUIText-Light;
      font-weight: 300;
      color: rgba(195, 195, 195, 1);
      line-height: 19px;
    div
      margin 0 auto
      width: 435px;
      font-size: 16px;
      font-family: PingFang-SC-Regular;
      font-weight: 400;
      color: rgba(155, 155, 155, 1);
      line-height: 22px;

  .videoOne
    width 1920px
    height 2000px
    background #ddd

  .SpanClick
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer
    margin-right 20px

  .ALlvisImg
    display flex
    /*justify-content space-around*/
    margin 0 auto
    width 1202px
    flex-wrap wrap
    .visImg
      width 260px
      // height 324px
      margin-right 54px
      margin-top 38px
      &:nth-child(4n)
        margin-right 0
      video
        width 260px
        height 260px
        margin-bottom 16px
        background rgba(239, 239, 239, 0.75);
      div
        &:nth-child(2)
          width: 266px;
          height: 48px;
          font-size: 20px;
          font-family: SFUIText-Regular;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 24px;

  .pageAll
    text-align center
    margin-top 60px
    span
      display inline-block
      width: 32px;
      height: 32px;
      background: rgba(220, 221, 221, 1);
      font-size: 16px;
      font-family: SFUIText-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height 32px
      text-align center
  .videoAll
    width 100%
    height 2000px
    z-index 10
    background rgba(0,0,0,0.4);
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)
  .videoDiv
    z-index 11
    width 975px
    height 638px
    position fixed
    background white
    top 50%
    left 50%
    transform translate(-50%, -50%)
    .videAll
      margin 34px 40px 30px 40px
      h1
        font-size: 22px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(74, 74, 74, 1);
      .video
        video
          width: 895px;
          height: 478px;
          background: #ddd;
          opacity 0.9
          margin 16px 0 25px 0
  .allvistit
    font-size:20px;
    font-family:SFUIText-Regular;
    font-weight:400;
    color:rgba(74,74,74,1);
    margin-top 16px
    line-height:24px;
  .openVideo
    display inline-block
    width: 51px;
    height: 24px;
    background: rgba(195, 195, 195, 1);
    border-radius: 3px;
    text-align center
    line-height 24px
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer

</style>



// WEBPACK FOOTER //
// src/components/vision.vue